"use strict";

exports.__esModule = true;
exports.applyTrailingSlashOption = void 0; // TODO(v5): Remove legacy setting and default to "always"

const applyTrailingSlashOption = function (input) {
  let option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : `legacy`;
  const hasHtmlSuffix = input.endsWith(`.html`);
  const hasXmlSuffix = input.endsWith(`.xml`);
  const hasPdfSuffix = input.endsWith(`.pdf`);
  if (input === `/`) return input;

  if (hasHtmlSuffix || hasXmlSuffix || hasPdfSuffix) {
    option = `never`;
  }

  if (option === `always`) {
    return input.endsWith(`/`) ? input : `${input}/`;
  }

  if (option === `never`) {
    return input.endsWith(`/`) ? input.slice(0, -1) : input;
  }

  return input;
};

exports.applyTrailingSlashOption = applyTrailingSlashOption;